var __jsx = React.createElement;
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import i18next from "i18next";
var AmenitiesComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.Amenities;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var AmenitiesPage = function AmenitiesPage() {
  var _store$common, _store$common2;
  var store = useStore();
  var router = useRouter();
  var conceptCode = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCode;
  var desc = store === null || store === void 0 || (_store$common2 = store.common) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.appAttributes) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.concept) === null || _store$common2 === void 0 ? void 0 : _store$common2.conceptCodeDesc;
  useEffect(function () {
    store === null || store === void 0 || store.initComponent("PrivateDining").then(function () {
      //
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("text.private_dining.page.amenities.title", {
    defaultValue: "Amenities |  Private Dining | ".concat(desc, " Restaurant")
  })), __jsx("meta", {
    name: "description",
    content: i18next.t("text.private_dining.page.amenities.metadescription", {
      defaultValue: "Get information on amenities such as private room accommodations, technology, parking, and more, for your next private dining experience at ".concat(desc, ".")
    })
  }), __jsx("script", {
    src: "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
    defer: true
  }), __jsx("script", {
    src: "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js",
    defer: true
  }), __jsx("link", {
    rel: "stylesheet",
    href: "/pd/common/common.css"
  }), conceptCode ? __jsx("link", {
    rel: "stylesheet",
    href: "/pd/css/".concat(conceptCode === null || conceptCode === void 0 ? void 0 : conceptCode.toLocaleLowerCase(), "_PD.css")
  }) : null), __jsx(AmenitiesComp, {
    route: router === null || router === void 0 ? void 0 : router.asPath
  }));
};
AmenitiesPage.layout = PageLayout.NB_LAYOUT;
AmenitiesPage.layoutProps = {
  analyticsData: {
    pageName: "private-dining amenities",
    pageType: "private-dining"
  }
};
export default observer(AmenitiesPage);